<template>
    <div>
        <div class="row add-event" title="Event Type" v-if="isDisabled === false && !isLoad">
            <div class="created-details d-flex col-lg-12" style="margin-bottom: 10px;"
                 v-if="lblNewEditCalendar === 'Edit' && eventCreatorName !== '' && eventCreatedOn !== ''">
                <label style="font-weight: normal; width: 50%;">{{lang("Creator Name")}}: {{eventCreatorName}}</label>
                <label style="font-weight: normal; width: 50%; ">{{lang("Created On")}}: {{eventCreatedOn}}</label>
            </div>

            <div class="d-flex col-lg-12 addEvent-title">
                <el-input
                        v-model="inputEventTitle"
                        type="text"
                        :placeholder="lang('Event')+lang('Title')"
                        :disabled="this.isDisabled"
                >
                </el-input>
                <div class=" addEvent-btn-group ml-3">
                    <div v-if="this.lblNewEditCalendar==='New'||this.lblNewEditCalendar==='NewfromButton'">
                        <el-button class="btnCreateEvent" v-on:click="btnCreateEvent()"
                                   :disabled="this.isDisabled">
                            {{lang("Save")}}
                        </el-button>
                    </div>
                    <div style="display: inherit;">
                        <div v-if="lblNewEditCalendar !== 'New' && lblNewEditCalendar !== 'NewfromButton' && !isLoad">
                            <el-button class="btnCreateEvent" v-on:click="btnEditEvent(optParentSignUp)"
                                       :disabled="this.isDisabled">
                                {{lang("Save")}}
                            </el-button>
                        </div>
                        <el-dropdown class="ml-3" @command="editEventMoreAction"
                                     v-if="this.lblNewEditCalendar!=='New'">
                            <el-button type="info">
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="deleteEvent">{{lang("Remove")}}{{lang("Event")}}</el-dropdown-item>
                                <el-dropdown-item command="sendEventEmail">{{lang("Send Email Invitation")}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 mt-2 event-details_item">
                <el-select v-model="rdEventType" :placeholder="lang('Event')+lang('Type')" :disabled="(this.isDisabled || !isValidAction)"
                           v-if="checkedUser !== 'Teacher'" @change="clearData()">
                    <el-option
                            v-for="item in rdEventTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="rdEventType" :placeholder="lang('Event')+lang('Type')" :disabled="(this.isDisabled || !isValidAction)"
                           v-if="checkedUser === 'Teacher'" @change="clearData()">
                    <el-option v-if="(schID === 'SCH201400000480' || schID === 'SCH201400000501' || schID === 'SCH201500000032'
                                || schID === 'SCH201400000497' || schID === 'SCH201500000054' || schID === 'SCH201400000553' 
                                || schID === 'SCH201400000510' || schID === 'SCH201500000074')"
                               v-for="item in rdEventTypeList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                    <el-option v-else
                               label="E-learning"
                               value="Elearning">
                    </el-option>
                </el-select>
            </div>

            <div class="col-lg-12 mt-2" v-if="rdEventType !== 'PTC'">
                <div class="event-start-datetime">
                    <small>{{lang("Select Start Datetime")}}</small>
                    <datetime
                            input-id="start-datetime"
                            input-class="start-datetime"
                            type="datetime"
                            :min-datetime="evtMinDate"
                            format="dd/MM/yyyy HH:mm"
                            v-model="evtStartDatetime"
                            :disabled="!isValidAction">
                    </datetime>
                </div>

                <div class="event-end-datetime">
                    <small>{{lang("Select End Datetime")}}</small>

                    <datetime
                            input-id="end-datetime"
                            input-class="end-datetime"
                            type="datetime"
                            :min-datetime="evtStartDatetime"
                            format="dd/MM/yyyy HH:mm"
                            v-model="evtEndDatetime"
                            :disabled="!isValidAction">
                    </datetime>
                </div>

            </div>

            <div class="col-lg-12 mt-2" v-if="rdEventType === 'PTC'">
                <div>
                    <el-checkbox :disabled="this.isDisabled" v-model="isWeekend">
                        {{lang("Allow Select Weekend")}}
                    </el-checkbox>
                </div>

                <div class="ptc-date-range-container" style="margin-bottom: 10px;">
                    <small>{{lang("Select date range")}}</small>

                    <el-date-picker
                            :disabled="!isValidAction"
                            v-model="ptcDaterange"
                            type="daterange"
                            :range-separator="lang('ETo')"
                            :start-placeholder="lang('Start Date')"
                            :end-placeholder="lang('End Date')"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy"
                            @change="combinePTCDateTime()"
                            :picker-options="datePicker">
                    </el-date-picker>
                </div>

                <div class="ptc-time-range-container">
                    <small>{{lang("Select Start Time")}}</small>

                    <el-time-select
                            :disabled="!isValidAction"
                            v-model="ptcStartTime"
                            :picker-options="{
                                start: '08:00',
                                step: '00:01',
                                end: '18:00'
                              }"
                            :placeholder="lang('Select Start Time')"
                            @change="combinePTCDateTime()">
                    </el-time-select>

                    <small>{{lang("Select End Time")}}</small>

                    <el-time-select
                            :disabled="!isValidAction"
                            v-model="ptcEndTime"
                            :picker-options="{
                                start: '08:00',
                                step: '00:01',
                                end: '18:30',
                                minTime: ptcStartTime
                              }"
                            :placeholder="lang('Select End Time')"
                            @change="combinePTCDateTime()">
                    </el-time-select>

                  <small>PTM is held</small>

                    <el-radio-group v-if="rdEventType === 'PTC'" v-model="eventFormat" class="event-onoffline">
                        <el-radio label="online" border>Virtually</el-radio>
                        <el-radio label="offline" border>Face-to-Face</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="col-lg-12 mt-2">
                <label>{{lang("Remarks")}} : </label>
                <el-input v-model="evtRemark" type="textarea" :rows="6" maxlength="3000" placeholder="Please input remarks"></el-input>
            </div>

            <div class="col-lg-12 mb-3" style="margin: 10px 0px;">
                <span style="display: block; font-weight: bold;">{{lang("Material")}} : </span>
                <input type="file" multiple class="inputfile"
                       id="FU_Portfolio" @change="onFileChanged"/>
                <label for="FU_Portfolio">{{lang("Select File(s)")}}</label>

                <div v-if="arrobj_SelectedFiles&&arrobj_SelectedFiles.length > 0" v-for="(obj_Images, key) of arrobj_SelectedFiles"
                     :key="(obj_Images, key).id" style="position: relative;">
                    <label>
                        <span v-if="obj_Images.name">{{obj_Images.name}}</span>
                        <span v-if="obj_Images.EventFIleName">{{obj_Images.EventFIleName}}</span>
                        <span class="each-file-close" @click="cancelFiles(obj_Images, key)"><span style="vertical-align: text-bottom;">x</span></span>
                    </label>

                </div>

                <div class="btn btn-primary" v-if="arrobj_SelectedFiles && arrobj_SelectedFiles.length > 0" @click="clearPreview()"><strong>X</strong>
                    {{lang("Remove All")}}
                </div>
            </div>

            <div class="col-lg-12 mt-2 event-parentSignUp" v-if="rdEventType === 'Event'">
                <el-checkbox :disabled="this.isDisabled" v-model="optParentSignUp" @change="checkParentSignup()">
                    {{lang("Allow Parent Sign Up")}}
                </el-checkbox>
            </div>
            <div class="col-lg-12" v-if="rdEventType === 'PTC' || rdEventType === 'Event' || rdEventType === 'Elearning'">
                <label class="createEvent_details-title" v-if="rdEventType !== 'Elearning'">{{lang("Event Details")}}</label>
                <div>
                    <div class="event-details_item" v-if="optParentSignUp===true && rdEventType !== 'PTC'">
                        <i class="material-icons">
                            group
                        </i>
                        <div class="event-cutoff">
                            <label>{{lang("Maximum Participants")}}</label>
                            {{inputEventRegLimit}}
                            <el-slider
                                    v-model="inputEventRegLimit"
                                    :disabled="this.isDisabled"
                                    show-input
                                    :max="3000"
                                    value=0>
                            </el-slider>
                        </div>
                    </div>
                    <div class="event-details_item" v-if="optParentSignUp===true && rdEventType !== 'PTC'">
                        <i class="material-icons">
                            date_range
                        </i>
                        <div class="event-cutoff">
                            <label>{{lang("Registration Cutoff (Days)")}}</label>
                            <el-slider
                                    v-model="inputEventRegCutOffDay"
                                    :disabled="this.isDisabled"
                                    show-input
                                    :max="10"
                                    value=0>
                            </el-slider>
                        </div>
                    </div>
                    <div class="event-details_item" v-if="rdEventType === 'Event'">
                        <i class="material-icons">
                            access_time
                        </i>
                        <div class="event-register-time">
                            <label>{{lang("Event Registration Time")}}</label>
                            <el-date-picker ref="regTime"
                                    v-model="inputEventRegistrationStartTime"
                                    type="datetime"
                                    :start-placeholder="lang('Event Registration Time')"
                                    format="dd/MM/yyyy HH:mm:ss"
                                    value-format="dd/MM/yyyy HH:mm:ss"
                                    :picker-options="registerDatePicker"
                                    @change="datePickerChange('inputEventRegistrationStartTime')">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="event-details_item" v-if="optParentSignUp===true&&checkedUser === 'Teacher' || (rdEventType === 'PTC')">
                        <i class="material-icons">
                            timelapse
                        </i>
                        <div class="event-details_duration">
                            <el-select v-model="EventDuration" :placeholder="lang('Duration')" v-if="rdEventType === 'PTC'"
                                       @change="rdEventType === 'PTC' ? generateTimeSlot() : ''"
                                       :disabled="(this.isDisabled || !isValidAction)">
                                <el-option
                                        :label="'5 '+lang('min')"
                                        value="5">
                                </el-option>
                                <el-option
                                        :label="'10 '+lang('min')"
                                        value="10">
                                </el-option>
                                <el-option
                                        :label="'15 '+lang('min')"
                                        value="15">
                                </el-option>
                                <el-option
                                        :label="'20 '+lang('min')"
                                        value="20">
                                </el-option>
                                <el-option
                                        :label="'25 '+lang('min')"
                                        value="25">
                                </el-option>
                            </el-select>

                            <el-select v-model="EventDuration" :placeholder="lang('Duration')" v-if="rdEventType !== 'PTC'"
                                       @change="rdEventType === 'PTC' ? generateTimeSlot() : ''"
                                       :disabled="(this.isDisabled || !isValidAction)">
                                <el-option
                                        :label="'0.5 '+lang('hour')"
                                        value="30">
                                </el-option>
                                <el-option
                                        :label="'1 '+lang('hour')"
                                        value="60">
                                </el-option>
                                <el-option
                                        :label="'1.5 '+lang('hour')"
                                        value="90">
                                </el-option>
                                <el-option
                                        :label="'2 '+lang('hour')"
                                        value="120">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="event-details_item" v-if="rdEventType !== 'Elearning'">
                        <i class="material-icons">
                            navigation
                        </i>
                        <el-input type="text" v-model="inputEventLocation" :placeholder="lang('Location')"
                                  :disabled="this.isDisabled"></el-input>
                    </div>
                </div>

                <div v-if="rdEventType === 'Elearning' || rdEventType === 'PTC'">

                <div v-if="!eventStart">
                    <vue-countdown-timer
                            @end_callback="checkEventStart('end')"
                            :start-time="countdownStart"
                            :end-time="countdownEnd"
                            :interval="1000"
                            :start-label="'Until start:'"
                            :end-label="'Google meet link show time '"
                            label-position="begin"
                            :end-text="'Event start now!'"
                            :day-txt="'days '"
                            :hour-txt="'hours '"
                            :minutes-txt="'minutes '"
                            :seconds-txt="'seconds'">
                        <template slot="countdown" slot-scope="scope">
                            <span>{{scope.props.days}}</span><i>{{scope.props.dayTxt}}</i>
                            <span>{{scope.props.hours}}</span><i>{{scope.props.hourTxt}}</i>
                            <span>{{scope.props.minutes}}</span><i>{{scope.props.minutesTxt}}</i>
                            <span>{{scope.props.seconds}}</span><i>{{scope.props.secondsTxt}}</i>
                        </template>
                    </vue-countdown-timer>
                </div>

                <div v-if="schID == 'SCH201400000480' || schID == 'SCH201400000510' ">
                <div v-if="createdGoogleCalendarEventLink !== '' && rdEventType === 'Elearning' && !isExpired && checkShowDatetime && eventStart" style="margin: 10px 0px;">

                    <i class="fa fa-video-camera" aria-hidden="true"></i>
                    <span>{{lang("Google Meet Link")}} : <a :href="createdGoogleCalendarEventLink" target="_blank" rel="noopener noreferrer">{{createdGoogleCalendarEventLink}}</a></span>
                </div>
                <div v-if="createdGoogleCalendarID !== '' && rdEventType === 'Elearning' && !isExpired && checkShowDatetime && eventStart"  style="margin: 10px 0px;">
                    <span>Google Meet Code : {{createdGoogleCalendarID}}</span>
                </div>
                </div>
                <div v-else>
                     <div v-if="createdGoogleCalendarEventLink !== '' && rdEventType === 'Elearning' && !isExpired" style="margin: 10px 0px;">
                    <i class="fa fa-video-camera" aria-hidden="true"></i>
                    <span>{{lang("Google Meet Link")}} : <a :href="createdGoogleCalendarEventLink" target="_blank" rel="noopener noreferrer">{{createdGoogleCalendarEventLink}}</a></span>
                     </div>
                </div>

                </div>

                <div class="row" style="margin: 0px;" v-if="lblNewEditCalendar !== 'New'">
                    <button class="btn" @click="showTimeslotModal()"
                            style="background: #409eff; color: #ffffff; margin-left: auto; border-radius: 5px;">{{lang("View time slot details")}}</button>
                </div>

                <div class="generated-time-slot-container" style="width: 100%; margin-top: 10px;" v-if="rdEventType === 'PTC' && arrobj_generatedTimeslot.length > 0">
                    <small style="font-weight: 500; color: #777; font-size: 0.8em;">{{lang("Select Timeslot")}}</small>
                    <small style="display: block;">(* Disable time slot if not available!)</small>

                    <div class="generated-time-slot-date-container">
                        <el-select v-model="dropdownTimeslotDate">
                            <el-option v-for="(val, dateKey) in arrobj_generatedTimeslot"
                                    :label="val.eventTimeslotDate"
                                    :value="val.eventTimeslotDate">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="each-date-time-slot" :id="dateKey" v-for="(val, dateKey) in arrobj_generatedTimeslot"
                          v-if="dropdownTimeslotDate === val.eventTimeslotDate">

                        <div class="col-md-12" style="padding: 0;">
                            <div class="each-time-slot-table"
                                 @click="(!timeslot.canEdit ? '' : selectTimeslot(timeKey, dateKey))"
                                 v-for="(timeslot, timeKey) in val.eventTimeslot" :id="'time-'+dateKey+'-'+timeKey"
                                 :class="(timeslot.EventTimeslotUserStatus === 'enable') ? '' : 'disable'">
                                <span class="ptc-par-name">{{timeslot.ptcPaxName}}</span>
                                <span>{{convertDatetime(timeslot.EventTimeslotStart, "time")}} - {{convertDatetime(timeslot.EventTimeslotEnd, "time")}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="event-add-participant" v-if="rdEventType === 'PTC' || rdEventType === 'Event' || rdEventType === 'Elearning'">
                    <label class="mt-4">{{lang("Tagged")}}{{lang("Students")}}</label>
                    <div class="event-participant_student">
                        <el-tag
                                v-for="guest in studentInt"
                                :key="guest.value"
                                closable
                                v-if="studentInt.length>0"
                                @close="removeStudentList(guest)"
                                class="mb-2"
                        >
                            {{guest.label}}
                        </el-tag>

                        <div class="lds-ellipsis" v-if="studentInt.length === 0 && isLoad && lblNewEditCalendar !== 'New'">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>

                        <el-button v-on:click="showClassModal()" size="small">+ {{lang("Tagged")}}{{lang("Students")}}</el-button>
                    </div>
                    <label class="mt-2" v-if="rdEventType === 'Event'">
                        {{lang("Add External Participant")}}
                    </label>
                    <div class="event-participant_parent" v-if="rdEventType === 'Event'">
                        <el-tag
                                v-for="guest in guestInt"
                                :key="guest.value"
                                closable
                                v-if="guestInt.length>0"
                                @close="removeParticipantList(guest)"
                                class="mb-2"
                        >
                            {{guest.value}}
                        </el-tag>
                        <el-input
                                class="input-new-tag"
                                v-if="inputVisible"
                                v-model="inputEventParticipant"
                                ref="saveTagInput"
                                size="small"
                                type="email"
                                @keyup.enter.native="addToParticipantList"
                                @blur="handleInputConfirm"
                                :disabled="this.isDisabled"
                                :placeholder="lang('Please enter participant emails separated by commas')"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ {{lang("Add")}}{{lang("Email")}}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="lds-ellipsis" v-if="isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>

        <b-modal id="modal_RemoveItem" :title="lang('Remove')" ref="modal_RemoveItem" centered ok-title="Yes"
                 @ok="removeItems('y')" cancel-title="No" @cancel="removeItems('n')">
            <div class="form-group">
                <div>
                    <label>You want to send email to inform user this event has been deleted?</label>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal_TimeslotList" :title="lang('View')" ref="modal_TimeslotList" centered ok-only :ok-title="lang('Close')">
            <div class="form-group">

                <div>
                    <label>
                        <span @click="openMoreGuidance()" style="text-decoration: underline; cursor: pointer;">Click here</span> for more guidance
                    </label>

                    <div v-if="isMoreGuidance">
                        <p><b>What to do before joining the call</b> <br/>
                            1. Use google chrome in incognito mode <br/>
                            - on google chrome press Ctrl + shift + n button to open incognito mode
                            <br/><br/>
                            2. close any tab on chrome that you don't need
                            <br/><br/>
                            3. ensure other not required applications are closed
                            <br/><br/>
                            4. be early so that you won't miss admitting the parent to join the call
                            <br/><br/>
                            5. log out other device that not required from the network
                            <br/><br/>
                            6. have your mobile phone pre-installed google meet and logged in as a backup
                            <br/><br/>

                            <b>What to do when a call drop</b><br/>

                            1. try to rejoin the call if the lag is on you, or get the parent to rejoin if they are the lagging party
                            <br/><br/>
                            2. if you are sharing your screen, try to stop the sharing.
                            <br/><br/>
                            3. The video quality is set to auto-adjust by default. If the lag persists consider switching to audio-only and try turn back on video when you feel is getting smooth back.
                            <br/><br/>
                            4. if the connectivity still drops after the switch to audio. consider switching to the backup plan that you prepared earlier on (6)</p>
                    </div>
                </div>

                <div class="each-time-slot-list" :id="dateKey" v-for="(val, dateKey) in arrobj_generatedTimeslot">

                    <header class="" role="tab" style="border-bottom: 1px solid #dee2e6;" v-if="val.isShow">
                        <div class="row">
                            <div class="col-12 header-tag">
                                <div class="btn btn-primary" style="border-left: unset;">
                                    <div v-b-toggle="'date-'+dateKey" style="height: 25px;">
                                        <span>{{val.eventTimeslotDate}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    <b-collapse :id="'date-'+dateKey" role="tabpanel">
                        <div class="col-md-12" style="padding: 0;">
                            <div class="each-time-slot-container" style="padding-left: 10px;"
                                 v-for="(timeslot, timeKey) in val.eventTimeslot" :id="'time-'+dateKey+'-'+timeKey">

                                <header class="" role="tab" style="border-bottom: 1px solid #dee2e6;" v-if="timeslot.ptcPaxName">
                                    <div class="row">
                                        <div class="col-12 header-tag">
                                            <div class="btn btn-primary" style="border-left: unset;">
                                                <div v-b-toggle="'time-'+dateKey+'-'+timeKey" style="height: 25px;">
                                                    <span>{{convertDatetime(timeslot.EventTimeslotStart, "time")}} - {{convertDatetime(timeslot.EventTimeslotEnd, "time")}}</span>
                                                    <span v-if="timeslot.ptcPaxName">----- ( {{timeslot.ptcPaxName}} )</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <b-collapse :id="'time-'+dateKey+'-'+timeKey" role="tabpanel">
                                    <div class="" style="padding: 20px;">
                                        <span v-if="timeslot.EventTimeslotHangoutLink">
                                            {{lang("Google Meet Link")}} : {{timeslot.EventTimeslotHangoutLink}}
                                        </span>
                                        <span v-if="!timeslot.EventTimeslotHangoutLink">
                                            No Hangout Link
                                          <button class="btn" @click="generateHangoutLink(timeslot)"
                                                  style="background: #409eff; color: #ffffff; margin-left: auto; border-radius: 5px;">{{lang("Generate Hangout Link")}}</button>
                                        </span>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </b-collapse>

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import DataSource from "../../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';
    import $ from "jquery";
    import {lang} from '../../locale/index';

    import Vue from 'vue';
    import { Datetime } from 'vue-datetime';
    // You need a specific loader for CSS files
    import 'vue-datetime/dist/vue-datetime.css';
    Vue.use(Datetime);

    import VueCountdownTimer from 'vuejs-countdown-timer';
    Vue.use(VueCountdownTimer);

    export default {
        name: "Event_Modal_Component",
        components: {
            datetime: Datetime,
        },
        data() {
            let vm = this;
            return {
                inputEventTitle: '',
                lblNewEditCalendar: '',
                inputEventTime: [],
                datePicker: {
                    disabledDate(date) {
                        return date < (new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
                    }
                },
                optParentSignUp: false,
                passOptParentSignUp: '',
                userType: "",
                guestInt: [],
                inputVisible: false,
                inputEventParticipant: "",
                studentInt: [],
                isDisabled: false,
                rdEventType: '',
                rdEventTypeRule: false,
                rdEventTypeList: [
                    {
                        value: 'Elearning',
                        label: lang('Elearning')
                    },
                    {
                        value: 'Event',
                        label: lang('Event')
                    }, {
                        value: 'SchoolClosure',
                        label: lang('School Closure')
                    }, {
                        value: 'PublicHoliday',
                        label: lang('Public Holiday')
                    }, {
                        value: 'PTC',
                        label: lang('Parent Teacher Conference')
                    },
                ],
                checkedUser: "",
                inputEventRegLimit: 0,
                inputEventRegCutOffDay: 0,
                inputEventRegistrationStartTime: '',
                inputEventLocation: '',
                inputEventParticipantList: [],
                inputValue: '',
                inputEventParticipantType: '',
                arrobj_SelectedFiles: [],
                selectedFiles: [],
                images: [],
                EventDuration: '',
                oldEventFileID: '',
                isUploadFile: false,
                EditEvent: '',
                registerTimeChange: false,
                inputTimeChange: false,
                arrobj_generatedTimeslot: [],
                arrobj_Timeslot: [],
                arrobj_respEventTimeslot: [],
                isValidAction: true,
                registerDatePicker: {
                    disabledDate(date) {
                        return vm.getEnabledDates(date);
                    }
                },
                enabledDates: [],
                optEventConference: false,
                dropdownTimeslotDate: "",
                createdGoogleCalendarID: '',
                createdGoogleCalendarEventLink: '',
                arr_SelectedFileList: [],
                convertedFileForInsert: [],
                eventCreatedBy: '',
                loginUserID: '',
                isExpired: false,
                assTeacherIds: '',
                pierTeachersIds: '',
                classTeacherIds: '',
                isRelatedUser: false,
                eventCreatedOn: '',
                eventCreatorName: '',
                optEnableLink: false,
                evtStartDatetime: '',
                evtEndDatetime: '',
                evtDateRange: [],
                evtTimeRange: [],
                evtMinDate: '',
                checkShowDatetime: false,
                evtRemark: '',
                // evtDatetimeFormat:{},
                schID: '',
                countdownStart: '',
                countdownEnd: '',
                eventStart: false,
                showCountdownMsg: true,
                serverCurrentDatetime: '',
                isLoad: true,
                MasterParticipantList: [],
                CurrentParticipantList: [],
                ParticipantNameListIntTemp: [],
                ParticipantNameListInt: [],
                tempParticipantList: [],
                newStudentInt: [],
                ptcDaterange: [],
                ptcTimerange: [],
                ptcStartTime: '00:00',
                ptcEndTime: '00:00',
                isWeekend: false,
                isMoreGuidance: false,
                eventFormat: 'online'
            };
        },
        async created() {
            if (this.lblNewEditEvent === "Edit") {
                await this.getEventParticipantList();
            } else {
                this.isLoad = false;
            }
            await this.initEvent();
        },
        mounted() {
            const self = this;
            // this.initEvent();
            self.loadWhitelist();
            this.userType = Cookies.get('userTypeSession');
            this.sessionID = Cookies.get('userIDSession');
            this.loginUserID = Cookies.get('userIDSession');
            this.schID = Cookies.get('schoolSession');
            for (let image of this.images) {
                let url = "data:" + image.GalFileType + ";base64," + image.GalFileLow;
                let fileName = image.GalFileName + image.GalFileExt;
                let mimeType = image.GalFileType;
                this.urltoFile(url, fileName, mimeType).then((file) => {
                    this.arrobj_SelectedFiles.push(file);
                }).finally(() => {
                    this.getImagePreviews();
                });
            }
            // $("#FU_Portfolio").on("change", function (e) {
            //     self.onFileChanged(e);
            // });
        },
        props: ["isDisable", "lblNewEditEvent", "eventCheckedUser", "eventStudentInt", "eventInputEventTitle", "eventInputEventTime",
            "eventOptParentSignUp", "eventRdEventType", "eventInputEventRegLimit", "eventInputEventRegCutOffDay",
            "eventInputEventRegistrationStartTime", "eventInputEventLocation", "eventGuestInt", "eventDurationHour", "eventID", "eventFiles",
            "eventPtcPar", "hangoutEventLink", "googleCalendarEventID", "paramEventCreatedBy", "paramTeacherIds", "paramEventCreatedOn",
            "paramEventCreatorName", "paramEventRemark", "paramPierTeachersIds", "paramClassTeacherIds", "paramServerCurrentDatetime", "paramEventFormat"],
        methods: {
            lang,
            async initEvent() {
                this.evtMinDate = moment().toISOString();
                this.isDisabled = this.isDisable;
                this.lblNewEditCalendar = this.lblNewEditEvent;
                this.checkedUser = this.eventCheckedUser;
                this.studentInt = this.eventStudentInt;
                this.inputEventTitle = this.eventInputEventTitle;
                this.inputEventTime = this.eventInputEventTime;
                this.optParentSignUp = this.eventOptParentSignUp;
                this.rdEventType = this.eventRdEventType;
                this.inputEventRegLimit = this.eventInputEventRegLimit;
                this.inputEventRegCutOffDay = this.eventInputEventRegCutOffDay;
                this.inputEventRegistrationStartTime = this.eventInputEventRegistrationStartTime;
                if (this.eventInputEventLocation !== undefined) {
                    this.inputEventLocation = this.eventInputEventLocation;
                }
                this.guestInt = this.eventGuestInt;
                this.EventDuration = this.eventDurationHour;
                this.selectedEventID = this.eventID;
                if (this.eventFiles.Table) {
                    this.arrobj_SelectedFiles = this.eventFiles.Table;

                    this.convertSelectedFilesToFileFormat();
                }

                if (this.inputEventTime[0].toString() !== "Invalid Date" && this.inputEventTime[1].toString() !== "Invalid Date") { // changes
                    this.inputEventTime[0] = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
                    this.inputEventTime[1] = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
                } else {
                    this.inputEventTime[0] = moment().format("DD/MM/YYYY HH:mm:ss");
                    this.inputEventTime[1] = moment().format("DD/MM/YYYY HH:mm:ss");
                }

                if (this.rdEventType === "PTC") {
                    this.ptcDaterange[0] = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
                    this.ptcDaterange[1] = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
                    this.ptcStartTime = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");
                    this.ptcEndTime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");
                }

                this.evtStartDatetime = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").toISOString();
                this.evtEndDatetime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").toISOString();

                if (this.inputEventRegistrationStartTime !== "") { // changes
                    this.inputEventRegistrationStartTime = moment(this.inputEventRegistrationStartTime).format("DD/MM/YYYY HH:mm:ss");
                }

                if (this.rdEventType === "PTC") {
                    this.arrobj_Timeslot = [];
                  this.$vs.loading();

                    let timeslotResp = await DataSource.shared.getPtcTimeslots(this.selectedEventID);

                    if (timeslotResp.Table) {
                        this.arrobj_Timeslot = timeslotResp.Table;
                        this.convertedEventTimeslotDisplay();
                    }
                  this.$vs.loading.close();

                }

                if (this.hangoutEventLink) {
                    this.createdGoogleCalendarEventLink = this.hangoutEventLink;
                }

                if (this.googleCalendarEventID) {
                    this.createdGoogleCalendarID = this.googleCalendarEventID;
                }

                if (this.lblNewEditCalendar === "Edit") {
                    this.isValidAction = false;
                }

                if (this.paramEventCreatedBy) {
                    this.eventCreatedBy = this.paramEventCreatedBy;
                }

                if (this.paramTeacherIds) {
                    this.assTeacherIds = this.paramTeacherIds;
                }

                if (this.paramPierTeachersIds) {
                    this.pierTeachersIds = this.paramPierTeachersIds;
                }

                if (this.paramClassTeacherIds) {
                    this.classTeacherIds = this.paramClassTeacherIds;
                }

                this.eventCreatedOn = this.paramEventCreatedOn;
                this.eventCreatorName = this.paramEventCreatorName;

                if (this.paramEventRemark) {
                    this.evtRemark = this.paramEventRemark;
                }

                if (this.paramEventFormat) {
                  this.eventFormat = this.paramEventFormat;
                }

                if (this.paramServerCurrentDatetime) {
                    this.serverCurrentDatetime = this.paramServerCurrentDatetime;
                }

                this.getEnabledDates();
                this.checkEventExpired();
                this.checkRelatedUser();
                this.checkDatetime();
            },
            datePickerChange(change){
                if (change === "inputEventRegistrationStartTime"){
                    this.registerTimeChange = true;
                }
                if (change === "inputEventTime"){
                    this.inputTimeChange = true;

                    if (this.inputEventTime !== null) { // changes
                        let startTime = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");
                        let endTime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");
                        if (startTime > endTime) {
                            let newDatetime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY") + ' ' + startTime;
                            this.inputEventTime[1] = newDatetime;
                        }

                        if (this.rdEventType === "PTC") {
                            this.generateTimeSlot();
                        }

                        this.getEnabledDates();
                    }
                }
            },
            clearPickerChange(){
                    this.registerTimeChange = false;
                    this.inputTimeChange = false;
            },
            checkrdEventType() {
                if (this.rdEventType === 'Event' || this.rdEventType === 'PTC') {
                    this.rdEventTypeRule = true;
                }
            },
            async btnCreateEvent() {
                try {
                    await this.checkParentSignup();

                    this.inputEventTime[0] = moment(this.evtStartDatetime).format("DD/MM/YYYY HH:mm:ss");
                    this.inputEventTime[1] = moment(this.evtEndDatetime).format("DD/MM/YYYY HH:mm:ss");

                    let Obj = {
                        EventTitle: this.inputEventTitle,
                        EventType: this.rdEventType,
                        EventStartTime: this.inputEventTime[0],
                        EventEndTime: this.inputEventTime[1],
                        EventRegistrationStartTime: (this.rdEventType === "PTC" ? "" : this.inputEventRegistrationStartTime),
                        EventParentSignUp: this.passOptParentSignUp,
                        EventRegCutOffDay: this.inputEventRegCutOffDay,
                        EventRegLimit: this.inputEventRegLimit,
                        EventLocation: this.inputEventLocation,
                        EventDuration: this.EventDuration,
                        EventLink: this.createdGoogleCalendarEventLink,
                        EventCalendarID: this.createdGoogleCalendarID,
                        EventRemarks: this.evtRemark,
                        EventFormat: this.eventFormat,
                    };

                    let guestIntSave = [];
                    guestIntSave.push(...this.guestInt);
                    if (this.studentInt) {
                        this.studentInt.forEach(item => {
                            let participantListDetail = {
                                Type: 'Student',
                                value: item.value,
                            };
                            guestIntSave.push(participantListDetail);
                        });
                    }

                    this.checkrdEventType();

                    if (!this.inputEventTitle) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert event title'),
                        });
                    } else if (String(this.inputEventTime[0]) === 'Invalid Date' || this.inputEventTime[1] === 'Invalid Date') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select date from'),
                        });
                    } else if (!this.rdEventType) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select event type'),
                        });
                    } else if (this.rdEventType === "PTC" && this.EventDuration === "") {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select duration'),
                        });
                    } else if (!this.inputEventLocation && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert location'),
                        });
                    } else if (!this.inputEventRegLimit && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert maximum participants'),
                        });
                    } else if (!this.inputEventRegCutOffDay && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert registration cutoff (days)'),
                        });
                    } else if (!this.inputEventRegistrationStartTime && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert registration time'),
                        });
                    } else if (moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").unix() > moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").unix()) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('End datetime cannot smaller than start datetime'),
                        });
                    } else {
                        this.$vs.loading();

                        if (this.rdEventType === "Elearning") {
                            if (this.schID === "SCH201400000480" || this.schID === "SCH201400000510") {
                                let randomRequestID = Math.random().toString(36).substring(2, 15);
                                Obj.EventLink = "https://meet.google.com/lookup/"+randomRequestID;
                                Obj.EventCalendarID = randomRequestID;
                                let response = {};
                                try {
                                    if (this.rdEventType === "PTC") {
                                        response = DataSource.shared.savePTCEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave), JSON.stringify(this.arrobj_Timeslot));
                                    } else {
                                        response = DataSource.shared.saveEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                                    }

                                    this.$vs.loading.close();
                                } catch (e) {
                                    console.log(e);
                                }

                                response.then((savedValue) => {

                                    if (savedValue.code === '88') {
                                        console.log('88');
                                        window.location.replace('/');
                                    } else if (savedValue.code === "99") {
                                        console.log('99');
                                    } else if (savedValue.code === '1') {
                                        this.$notify({
                                            title: lang('Success'),
                                            message: lang('Event Added'),
                                            type: 'success'
                                        });
                                        this.$emit("LoadEventDetails");
                                        this.$emit("hideEventShowModal");
                                    }

                                    this.$vs.loading.close();
                                });
                            } else {

                                await this.newGoogleCalendarEvent().then((resp) => {

                                    if (resp) {
                                        Obj.EventLink = this.createdGoogleCalendarEventLink;
                                        Obj.EventCalendarID = this.createdGoogleCalendarID;
                                        let response = {};
                                        try {
                                            if (this.rdEventType === "PTC") {
                                                response = DataSource.shared.savePTCEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave), JSON.stringify(this.arrobj_Timeslot));
                                            } else {
                                                response = DataSource.shared.saveEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                                            }

                                            this.$vs.loading.close();
                                        } catch (e) {
                                            console.log(e);
                                        }

                                        response.then((savedValue) => {

                                            if (savedValue.code === '88') {
                                                console.log('88');
                                                window.location.replace('/');
                                            } else if (savedValue.code === "99") {
                                                console.log('99');
                                            } else if (savedValue.code === '1') {
                                                this.$notify({
                                                    title: lang('Success'),
                                                    message: lang('Event Added'),
                                                    type: 'success'
                                                });
                                                this.$emit("LoadEventDetails");
                                                this.$emit("hideEventShowModal");
                                            }

                                            // this.$vs.loading.close();
                                        });

                                    } else {
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Integration problems!'),
                                        });
                                    }

                                    this.$vs.loading.close();
                                });
                            }
                        } else {
                            let response = {};
                            try {
                                if (this.rdEventType === "PTC") {
                                    response = DataSource.shared.savePTCEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave), JSON.stringify(this.arrobj_Timeslot));
                                } else {
                                    response = DataSource.shared.saveEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                                }

                                this.$vs.loading.close();
                            } catch (e) {
                                console.log(e);
                            }

                            response.then((savedValue) => {

                                if (savedValue.code === '88') {
                                    console.log('88');
                                    window.location.replace('/');
                                } else if (savedValue.code === "99") {
                                    console.log('99');
                                } else if (savedValue.code === '1') {
                                    this.$notify({
                                        title: lang('Success'),
                                        message: lang('Event Added'),
                                        type: 'success'
                                    });
                                    this.$emit("LoadEventDetails");
                                    this.$emit("hideEventShowModal");
                                }

                                this.$vs.loading.close();
                            });
                        }



                        // this.deleteGoogleCalendarEvent();
                        // let response = {};
                        // try {
                        //     if (this.rdEventType === "PTC") {
                        //         response = await DataSource.shared.savePTCEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave), JSON.stringify(this.arrobj_Timeslot));
                        //     } else {
                        //         response = await DataSource.shared.saveEvent(this.arrobj_SelectedFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                        //     }
                        //
                        //     this.$vs.loading.close();
                        // } catch (e) {
                        //     console.log(e);
                        // }
                        //
                        // if (response.code === '88') {
                        //     console.log('88');
                        //     window.location.replace('/');
                        // } else if (response.code === "99") {
                        //     console.log('99');
                        // } else if (response.code === '1') {
                        //     this.$notify({
                        //         title: lang('Success'),
                        //         message: lang('Event Added'),
                        //         type: 'success'
                        //     });
                        //     this.$emit("LoadEventDetails");
                        //     this.$emit("hideEventShowModal");
                        // }
                    }
                    // this.$vs.loading.close();
                } catch (e) {
                    console.log(e);
                    // alert(e);
                }
            },
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            checkParentSignup() {
                if (this.optParentSignUp === true) {
                    this.passOptParentSignUp = "Yes";
                } else {
                    this.passOptParentSignUp = "No";

                    this.inputEventRegLimit = 0;
                    this.inputEventRegCutOffDay = 0;
                    // this.EventDuration = "";
                }
            },
            convertEventDuration() {
                // if (this.EventDuration === "0.5") {
                //     this.EventDuration = 30;
                // } else if (this.EventDuration === "1") {
                //     this.EventDuration = 60;
                // } else if (this.EventDuration === "1.5") {
                //     this.EventDuration = 90;
                // } else if (this.EventDuration === "2") {
                //     this.EventDuration = 120;
                // }
            },
            async btnEditEvent(optParentSignUp) {
                try {

                    this.$vs.loading();
                    await this.sleep(200);
                    await this.checkParentSignup();
                    await this.convertEventDuration();
                    if (this.arrobj_SelectedFiles && this.isUploadFile === false) {
                        let oldEventFile = this.arrobj_SelectedFiles.map(m => m.EventFileID);
                        // this.oldEventFileID = oldEventFile.toString();
                        this.oldEventFileID = "nofile";
                    }

                    let guestIntSave = [];
                    guestIntSave.push(...this.guestInt);
                    if (this.studentInt) {
                        this.studentInt.forEach(item => {
                            let participantListDetail = {
                                Type: 'Student',
                                value: item.value,
                            };
                            guestIntSave.push(participantListDetail);
                        });
                    }

                    // if (this.registerTimeChange !== true && this.inputEventRegistrationStartTime !== null && this.inputEventRegistrationStartTime !== '') {
                    //     console.log("hihi");
                    //     this.inputEventRegistrationStartTime = moment(this.inputEventRegistrationStartTime).format("DD/MM/YYYY HH:mm:ss");
                    // }

                    if (this.inputTimeChange !== true) {
                        if (this.inputEventTime[0] === 'Invalid Date'||this.inputEventTime[1] === 'Invalid Date'){
                            this.inputEventTime = [];
                        }
                        // else{
                        //     this.inputEventTime[0] = moment(this.inputEventTime[0]).format("DD/MM/YYYY HH:mm:ss");
                        //     this.inputEventTime[1] = moment(this.inputEventTime[1]).format("DD/MM/YYYY HH:mm:ss");
                        // }
                        // console.log(this.inputEventTime,"inputEventTime");
                    }

                    await this.checkrdEventType();


                    if (!this.inputEventTitle) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert event title'),
                        });
                    } else if (this.inputEventTime===null) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select date from'),
                        });
                    } else if (!this.rdEventType) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select event type'),
                        });
                    } else if (!this.inputEventLocation && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert location'),
                        });
                    } else if (!this.inputEventRegLimit && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert maximum participants'),
                        });
                    } else if (!this.inputEventRegCutOffDay && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert registration cutoff (days)'),
                        });
                    } else if (!this.inputEventRegistrationStartTime && this.passOptParentSignUp === "Yes" && this.rdEventTypeRule) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert registration time'),
                        });
                    } else {
                        if (this.rdEventTypeRule) {
                            if (optParentSignUp === false){
                                this.editEvent = {
                                    EventID: this.selectedEventID,
                                    EventTitle: this.inputEventTitle,
                                    EventType: this.rdEventType,
                                    EventStartTime: this.inputEventTime[0],
                                    EventEndTime: this.inputEventTime[1],
                                    // EventRegistrationStartTime: "",
                                    // EventRegistrationStartTime: this.inputEventRegistrationStartTime,
                                    EventRegistrationStartTime: (this.rdEventType === "PTC" ? "" : this.inputEventRegistrationStartTime),
                                    EventParentSignUp: this.passOptParentSignUp,
                                    EventRegCutOffDay: "0",
                                    EventRegLimit: "0",
                                    EventLocation: this.inputEventLocation,
                                    EventDuration: this.EventDuration,
                                    OldEventFileID: this.oldEventFileID,
                                    // EventDesc:this:inputEventDesc

                                    EventLink: this.createdGoogleCalendarEventLink,
                                    EventCalendarID: this.createdGoogleCalendarID,
                                    EventRemarks: this.evtRemark,
                                    EventFormat: this.eventFormat,
                                };
                            }else{

                                // console.log(this.inputEventTime, "edit datetime");
                                this.editEvent = {
                                    EventID: this.selectedEventID,
                                    EventTitle: this.inputEventTitle,
                                    EventType: this.rdEventType,
                                    EventStartTime: this.inputEventTime[0],
                                    EventEndTime: this.inputEventTime[1],
                                    // EventRegistrationStartTime: this.inputEventRegistrationStartTime,
                                    EventRegistrationStartTime: (this.rdEventType === "PTC" ? "" : this.inputEventRegistrationStartTime),
                                    EventParentSignUp: this.passOptParentSignUp,
                                    EventRegCutOffDay: this.inputEventRegCutOffDay,
                                    EventRegLimit: this.inputEventRegLimit,
                                    EventLocation: this.inputEventLocation,
                                    EventDuration: this.EventDuration,
                                    OldEventFileID: this.oldEventFileID,
                                    // EventDesc:this:

                                    EventLink: this.createdGoogleCalendarEventLink,
                                    EventCalendarID: this.createdGoogleCalendarID,
                                    EventRemarks: this.evtRemark,
                                };
                            }
                        } else {
                            if (this.rdEventType !== "Elearning") {
                                this.editEvent = {
                                    EventID: this.selectedEventID,
                                    EventTitle: this.inputEventTitle,
                                    EventType: this.rdEventType,
                                    EventStartTime: this.inputEventTime[0],
                                    EventEndTime: this.inputEventTime[1],
                                    EventRegistrationStartTime: "",
                                    EventParentSignUp: "No",
                                    EventRegCutOffDay: "0",
                                    EventRegLimit: "0",
                                    EventLocation: "",
                                    EventDuration: "",
                                    OldEventFileID: this.oldEventFileID,
                                    // EventDesc:this:inputEventDesc

                                    EventLink: this.createdGoogleCalendarEventLink,
                                    EventCalendarID: this.createdGoogleCalendarID,
                                    EventRemarks: this.evtRemark,
                                };
                            } else {
                                // console.log(this.EventDuration, "duration");
                                this.editEvent = {
                                    EventID: this.selectedEventID,
                                    EventTitle: this.inputEventTitle,
                                    EventType: this.rdEventType,
                                    EventStartTime: this.inputEventTime[0],
                                    EventEndTime: this.inputEventTime[1],
                                    EventRegistrationStartTime: "",
                                    EventParentSignUp: "No",
                                    EventRegCutOffDay: "0",
                                    EventRegLimit: "0",
                                    EventLocation: "",
                                    EventDuration: this.EventDuration,
                                    OldEventFileID: this.oldEventFileID,
                                    EventPrivateLink:'',
                                    EventPrivateCode:'',
                                    // EventDesc:this:inputEventDesc

                                    EventLink: this.createdGoogleCalendarEventLink,
                                    EventCalendarID: this.createdGoogleCalendarID,
                                    EventRemarks: this.evtRemark,
                                };
                            }
                        }

                        // let filesToInsert = this.arrobj_SelectedFiles;
                        // if (Array.isArray(this.arrobj_SelectedFiles)) {
                        //     filesToInsert = undefined;
                        // }

                        let filesToInsert = this.convertedFileForInsert;

                        let response = {}; // const response
                        if (this.rdEventType === "PTC") {
                            let timeslotValid = "Y";

                            if (!this.isValidAction) {
                                timeslotValid = "N";
                            }

                            response = await DataSource.shared.updatePTCEvent(filesToInsert, JSON.stringify(this.editEvent), JSON.stringify(guestIntSave), JSON.stringify(this.arrobj_Timeslot), timeslotValid);
                        } else {
                            response = await DataSource.shared.updateEvent(filesToInsert, JSON.stringify(this.editEvent), JSON.stringify(guestIntSave));
                        }

                        if (response.code === '88') {
                            console.log('88');
                        } else if (response.code === "99") {
                            console.log('99');
                        }  else if (response.code === "3") {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('Maximum participants should not lower than registered pax')
                            });
                        } else if (response.code === '1') {
                            this.$notify({
                                title: lang('Success'),
                                message: lang('Event update successful'),
                                type: 'success'
                            });
                            this.$emit("hideEventShowModal");
                            this.$emit("refreshBModalValue");
                            this.$emit("LoadEventDetails");
                            // window.location.replace('/Event');
                            this.clearPickerChange();
                        }
                    }
                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e);
                    this.$vs.loading.close();

                }
            },
            editEventMoreAction(command) {
                if (command === "deleteEvent") {
                    // this.showConfirmSendEmailModal();
                    this.deleteGoogleCalendarEvent();
                    this.$emit("deleteEvent");
                } else if (command === "createEvent") {
                    this.$emit("eventNewEdit", "New");
                } else if (command === "sendEventEmail") {
                    this.$router.push('eventemail?id=' + this.selectedEventID);
                }
            },
            validEmail() {
                const re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(this.inputEventParticipant.toLowerCase());
            },
            addToParticipantList() {
                try {

                    const exist = this.guestInt.find(p => {
                        return p.value === this.inputEventParticipant;
                    });

                    if (this.validEmail() && !exist) {

                        let tempGuestInt = [];
                        let Type = "Others";
                        tempGuestInt.push(...this.inputEventParticipant.split(","));
                        // let emailList = [];
                        // if (this.inputEventParticipantType === "") {
                        //     this.inputEventParticipantType = "Others";
                        // }
                        tempGuestInt.forEach(m => {
                            let tempEmail = {
                                Type: Type,
                                value: m,
                            };
                            this.guestInt.push(tempEmail);
                        });
                        this.$forceUpdate();
                        // this.guestInt = emailList;
                        this.inputEventParticipant = '';
                        this.inputVisible = false;
                        this.inputValue = '';
                        this.inputEventParticipantType = '';
                    } else if (this.validEmail() && exist) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Email duplicated')
                        });
                    } else {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please insert valid email')
                        });
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.guestInt.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            showInput() {
                this.inputVisible = true;
            },
            showClassModal() {
                this.$emit("showClassModal");
            },
            removeStudentList(guest) {
                this.studentInt.splice(this.studentInt.indexOf(guest), 1);
            },
            removeParticipantList(guest) {
                this.guestInt.splice(this.guestInt.indexOf(guest), 1);
            },
            isImageByExt(obj_File) {
                let ext = String(obj_File.EventFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },

            getMediumSource(file) {
                let SourceisImage = this.isImageByExt(file);
                if (SourceisImage === true) {
                    return `data:image/jpg;base64, ${file.EventFileMedium}`;
                } else {
                    return `data:application/pdf;base64, ${file.EventFileOriginal}`;
                }
            },
            getLowSource(file) {
                return `data:image/jpg;base64, ${file.EventFileLow}`;
            },
            getFile(file) {
                return `data:${file.EventFileType};base64,${file.EventFileOriginal}`;
            },
            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            return new File([buf], filename, {type: mimeType});
                        })
                );
            },
            onFileChanged(event) {
                this.arr_SelectedFileList = [];

                this.isUploadFile = true;
                for (let file of event.target.files) {
                    let fileSize = file.size / 1024 / 1024;
                    if (fileSize > 10) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('File limit exceeded 10MB')
                        });
                    } else {
                        if (this.isWhitelist(file)) {
                            // this.arrobj_SelectedFiles = event.target.files;
                            this.arr_SelectedFileList = event.target.files;
                        } else {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('File Format Not Accepted')
                            });
                        }
                    }
                }

                if (this.arr_SelectedFileList && this.arr_SelectedFileList.length > 0) {
                    this.changeSelectedFilesFormat();
                }

                // if (this.arrobj_SelectedFiles && this.arrobj_SelectedFiles.length > 0) {
                //     this.getImagePreviews();
                // }

            },
            isWhitelist(file) {
                let temparrstr = file.name.split(".");
                let str_Ext = ("." + temparrstr[temparrstr.length - 1]).toUpperCase();
                let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.ext.toUpperCase() === str_Ext) !== -1;
                let isValidFile = file.size > 0;

                return (isWhitelisted && isValidFile);
            },
            async loadWhitelist() {
                await DataSource.shared.getWhitelist().then((result) => {
                    this.arrstr_Whitelist = result.Table;
                });
            },
            getImagePreviews() {
                /*
                  Iterate over all of the files and generate an image preview for each one.
                */
                for (let i = 0; i < this.arrobj_SelectedFiles.length; i++) {
                    /*
                      Ensure the file is an image file
                    */
                    if (/\.(jpe?g|png|gif)$/i.test(this.arrobj_SelectedFiles[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            if (this.$refs['image' + parseInt(i)]) {
                                this.$refs['image' + parseInt(i)][0].src = reader.result;
                            }
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.arrobj_SelectedFiles[i]);
                    }
                }
            },
            getSource(obj) {
                let imgsrc = "";
                if (obj.Profile_Img == null || obj.Profile_Img == "")
                    imgsrc = "data:image/png;base64,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";
                else
                    imgsrc = "data:" + obj.Profile_ImgType + ";base64," + obj.Profile_Img;
                return imgsrc;
            },
            isImage(obj_File) {
                let ext = String(obj_File.EventFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },
            clearPreview() {
                $("#FU_Portfolio").val("");
                this.arrobj_SelectedFiles = [];
                this.convertedFileForInsert = [];
            },
            /*#region Carousel Slider*/
            onSlideStart(slide) {
                this.sliding = true;
            },
            onSlideEnd(slide) {
                this.sliding = false;
            },

            generateTimeSlot() {
                this.inputEventTime[0] = moment(this.evtStartDatetime).format("DD/MM/YYYY HH:mm:ss");
                this.inputEventTime[1] = moment(this.evtEndDatetime).format("DD/MM/YYYY HH:mm:ss");

                if (this.EventDuration !== "" && this.inputEventTime[0].toString() !== "Invalid Date" && this.inputEventTime[1].toString() !== "Invalid Date") {
                    let startDateTime = this.inputEventTime[0];
                    let endDateTime = this.inputEventTime[1];

                    let startDate = moment(startDateTime, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
                    let endDate = moment(endDateTime, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");

                    let startTime = moment(startDateTime, "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");
                    let endTime = moment(endDateTime, "DD/MM/YYYY HH:mm:ss").format("HH:mm:ss");

                    this.convertEventDuration();

                    if (startTime < endTime) {
                        // let newStartTime = startTime;
                        let arr_timeslot = [];
                        let newDate = startDate;

                        let arr_date = [];
                        let a = 0;

                        let arrobj_eventTimeslotDate = [];
                        // while (newDate <= endDate) {
                        while ( new Date(moment(newDate, "DD/MM/YYYY").format("YYYY-MM-DD")) <= new Date(moment(endDate, "DD/MM/YYYY").format("YYYY-MM-DD")) ) {
                            let newStartTime = startTime;
                            // console.log(startTime, "date");
                            let obj_eventTimeslotDate = {};
                            let arrobj_eventTimeslot = [];

                            if (this.isWeekend) {
                                obj_eventTimeslotDate.eventTimeslotDate = newDate;

                                if (a === 0) {
                                    obj_eventTimeslotDate.isActive = true;
                                } else {
                                    obj_eventTimeslotDate.isActive = false;
                                }

                                while (newStartTime <= endTime) {
                                    let obj_eventTimeslot = {};
                                    obj_eventTimeslot.EventTimeslotStart = newDate + ' ' + newStartTime;
                                    obj_eventTimeslot.EventTimeslotUserStatus = "enable";

                                    newStartTime = moment(newStartTime, "HH:mm:ss")
                                        .add(this.EventDuration, 'minutes')
                                        .format('HH:mm:ss');

                                    obj_eventTimeslot.EventTimeslotEnd = newDate + ' ' + newStartTime;
                                    obj_eventTimeslot.canEdit = true;
                                    arrobj_eventTimeslot.push(obj_eventTimeslot);
                                }

                                obj_eventTimeslotDate.eventTimeslot = arrobj_eventTimeslot;
                                arrobj_eventTimeslotDate.push(obj_eventTimeslotDate);

                                a++;
                            } else {
                                if ( (moment(newDate, "DD/MM/YYYY").day() !== 0 && moment(newDate, "DD/MM/YYYY").day() !== 6) ) {
                                    obj_eventTimeslotDate.eventTimeslotDate = newDate;

                                    if (a === 0) {
                                        obj_eventTimeslotDate.isActive = true;
                                    } else {
                                        obj_eventTimeslotDate.isActive = false;
                                    }

                                    while (newStartTime <= endTime) {
                                        let obj_eventTimeslot = {};
                                        obj_eventTimeslot.EventTimeslotStart = newDate + ' ' + newStartTime;
                                        obj_eventTimeslot.EventTimeslotUserStatus = "enable";

                                        newStartTime = moment(newStartTime, "HH:mm:ss")
                                            .add(this.EventDuration, 'minutes')
                                            .format('HH:mm:ss');

                                        obj_eventTimeslot.EventTimeslotEnd = newDate + ' ' + newStartTime;
                                        obj_eventTimeslot.canEdit = true;
                                        arrobj_eventTimeslot.push(obj_eventTimeslot);
                                    }

                                    obj_eventTimeslotDate.eventTimeslot = arrobj_eventTimeslot;
                                    arrobj_eventTimeslotDate.push(obj_eventTimeslotDate);

                                    a++;
                                }
                            }

                            newDate = moment(newDate, "DD/MM/YYYY").add(1, 'days').format('DD/MM/YYYY');
                            // console.log(newDate, "haha");
                        }

                        this.arrobj_generatedTimeslot = arrobj_eventTimeslotDate;
                        this.convertedEventTimeslotParam();
                    } else {
                        alert("Please choose correct end Datetime for populate timeslot!");
                        console.log("error");
                    }
                }
            },

            convertedEventTimeslotParam() {
                this.arrobj_Timeslot = [];

                this.arrobj_generatedTimeslot.forEach(objectDate => {
                    objectDate.eventTimeslot.forEach(objectTimeslot => {
                        this.arrobj_Timeslot.push(objectTimeslot);
                    });
                });
            },

            convertedEventTimeslotDisplay() {
                // this.arrobj_respEventTimeslot = [];
                this.arrobj_generatedTimeslot = [];
                let arrTimeslotDate = [];
                let timeslotDate = "";

                this.arrobj_Timeslot.forEach(objectTimeslot => {
                    if ((timeslotDate === "" || timeslotDate !== moment(objectTimeslot.EventTimeslotStart).format("DD/MM/YYYY"))) {
                        arrTimeslotDate.push(moment(objectTimeslot.EventTimeslotStart).format("DD/MM/YYYY"));
                    }

                    objectTimeslot.canEdit = true;
                    if (objectTimeslot.EventTimeslotEventParID) {
                        this.isValidAction = false;
                        objectTimeslot.canEdit = false;
                    }

                    this.eventPtcPar.forEach(objParList => {
                        if (objParList.EventParID !== undefined) {
                            if (objParList.EventParID === objectTimeslot.EventTimeslotEventParID) {
                                objectTimeslot.ptcPaxName = objParList.PaxName;
                            }
                        }
                    });

                    timeslotDate = moment(objectTimeslot.EventTimeslotStart).format("DD/MM/YYYY");
                    objectTimeslot.convertedTimeslotDate = moment(objectTimeslot.EventTimeslotStart).format("DD/MM/YYYY");
                });
                let arr_convertTimeslot = this.groupBy(this.arrobj_Timeslot, "convertedTimeslotDate");

                let arrobj_eventTimeslotDate = [];
                // let arr_checkDuplicateDate = [];
                for (var a = 0; a < arrTimeslotDate.length; a++) {
                    let obj_eventTimeslotDate = {};

                    obj_eventTimeslotDate.isShow = false;
                    obj_eventTimeslotDate.eventTimeslotDate = arrTimeslotDate[a];
                    if (a === 0) {
                        obj_eventTimeslotDate.isActive = true;
                    } else {
                        obj_eventTimeslotDate.isActive = false;
                    }

                    for (var b = 0; b < arr_convertTimeslot[arrTimeslotDate[a]].length; b++) {
                        arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotStart = moment(arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotStart).format("DD/MM/YYYY HH:mm:ss");
                        arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEnd = moment(arr_convertTimeslot[arrTimeslotDate[a]][b].EventTimeslotEnd).format("DD/MM/YYYY HH:mm:ss");

                        if (arr_convertTimeslot[arrTimeslotDate[a]][b].ptcPaxName) {
                            obj_eventTimeslotDate.isShow = true;
                        }
                    }

                    obj_eventTimeslotDate.eventTimeslot = arr_convertTimeslot[arrTimeslotDate[a]];
                    arrobj_eventTimeslotDate.push(obj_eventTimeslotDate);
                }

                this.arrobj_generatedTimeslot = arrobj_eventTimeslotDate;

                this.convertedEventTimeslotParam();
            },

            previousDate(key) {
                this.arrobj_generatedTimeslot.forEach((object, index) => {
                    if ((key-1) === index) {
                        object.isActive = true;
                    } else {
                        object.isActive = false;
                    }
                });
            },
            nextDate(key) {
                this.arrobj_generatedTimeslot.forEach((object, index) => {
                    if ((key+1) === index) {
                        object.isActive = true;
                    } else {
                        object.isActive = false;
                    }
                });
            },

            convertDatetime(datetimeVal, type) {
                if (type === "date") {
                    return moment(datetimeVal, "DD/MM/YYYY LT").format("DD/MM/YYYY");
                } else {
                    return moment(datetimeVal, "DD/MM/YYYY LT").format("LT");
                }
            },

            selectTimeslot(timeKey, dateKey) {
                this.arrobj_generatedTimeslot.forEach((objectDate, indexDate) => {
                    objectDate.eventTimeslot.forEach((objectTimeslot, indexTimeslot) => {
                        if (indexDate === dateKey && indexTimeslot === timeKey) {
                            if (objectTimeslot.EventTimeslotUserStatus === "disable") {
                                objectTimeslot.EventTimeslotUserStatus = "enable";
                            } else {
                                objectTimeslot.EventTimeslotUserStatus = "disable";
                            }
                        } else {
                            if (objectTimeslot.EventTimeslotUserStatus !== "disable") {
                                objectTimeslot.EventTimeslotUserStatus = "enable";
                            }
                        }
                    });
                });

                // if ($("#time-"+dateKey+'-'+timeKey).css("background-color") === "rgba(0, 0, 0, 0)") {
                //     $("#time-"+dateKey+'-'+timeKey).css("background", "#409eff");
                //     $("#time-"+dateKey+'-'+timeKey).css("color", "white");
                // } else {
                //     $("#time-"+dateKey+'-'+timeKey).css("background", "rgba(0, 0, 0, 0)");
                //     $("#time-"+dateKey+'-'+timeKey).css("color", "black");
                // }

                this.convertedEventTimeslotParam();
            },

            groupBy(array, key) {
                const result = {}
                array.forEach((item, index) => {
                    if (!result[item[key]]){
                        result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                })
                return result;
            },

            getEnabledDates(date) {
                let convertedDate = moment(date).format("DD/MM/YYYY");
                // this.enabledDates = [];

                let startDateTime = this.inputEventTime[0];
                let endDateTime = this.inputEventTime[1];

                let startDate = moment(startDateTime, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
                let endDate = moment(endDateTime, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");

                if ( (date > (new Date().getTime() - (1 * 24 * 60 * 60 * 1000)) && convertedDate <= endDate) ) {
                    return false;
                } else {
                    return true;
                }
            },

            clearData() {
                this.optParentSignUp = false;
                this.inputEventRegLimit = 0;
                this.inputEventRegCutOffDay = 0;
                this.inputEventRegistrationStartTime = "";
                this.inputEventLocation = "";
                this.guestInt = [];
                this.EventDuration = "";
                this.optEventConference = false;
                this.arrobj_generatedTimeslot = [];
            },
            async generateHangoutLink(timeslot) {

              let randomRequestID = Math.random().toString(36).substring(2, 15);
                let evtType = "hangoutsMeet";
                let creatorEmail = Cookies.get('userEmailSession');
                let calEventTitle = this.inputEventTitle;
                let calendarStart = moment(timeslot.EventTimeslotStart, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                let calendarEnd = moment(timeslot.EventTimeslotEnd, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");

                let parentsEmail =  await DataSource.shared.GetParentsEmail(timeslot.EventParPaxID);
                console.log(parentsEmail[0].PAR_Father_Email);
                let attendeeEmail = creatorEmail;
                if (parentsEmail){
                  if(parentsEmail[0].PAR_Mother_Email){
                    attendeeEmail = parentsEmail[0].PAR_Mother_Email;
                  }
                  else if(parentsEmail[0].PAR_Father_Email){
                    attendeeEmail = parentsEmail[0].PAR_Father_Email;
                  }

                  let googleCalendarResp = await DataSource.shared.createGoogleCalendarEvent(creatorEmail, calEventTitle,
                    this.inputEventLocation, attendeeEmail, calendarStart, calendarEnd, randomRequestID, evtType, "ptcWithLink");

                  if(googleCalendarResp){
                    let hangoutlink = googleCalendarResp.hangoutLink;
                    let calEventID =googleCalendarResp.id
                    await this.updateParentTimeslotBooking(timeslot.EventTimeslotID, timeslot.EventParID,this.eventID, hangoutlink, calEventID);
                    await this.initEvent();

                  }
                }
                else{
                  this.$notify.error({
                    title: lang('Error'),
                    message: "No Parent Email!",
                  });
                }


              },

            async newGoogleCalendarEvent() {
                let creatorEmail = Cookies.get('userEmailSession');
                let randomRequestID = (this.rdEventType === 'Elearning') ? Math.random().toString(36).substring(2, 15) : "";
                let calendarStartDatetime = moment(this.inputEventTime[0], "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                let calendarEndDatetime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                let generateType = (this.rdEventType === "Event") ? "normal" : (this.rdEventType === "Elearning") ? "normalWithLink" : "";

                let googleCalendarResp = await DataSource.shared.createGoogleCalendarEvent(creatorEmail, this.inputEventTitle,
                    this.inputEventLocation, "", calendarStartDatetime, calendarEndDatetime, randomRequestID, "", generateType);

                if (googleCalendarResp) {
                    this.createdGoogleCalendarID = googleCalendarResp.id;
                    this.createdGoogleCalendarEventLink = googleCalendarResp.hangoutLink;
                }

                return googleCalendarResp;
            },

            async deleteGoogleCalendarEvent() {
                let creatorEmail = Cookies.get('userEmailSession');
                // this.createdGoogleCalendarID = "5cqtveurrd4e43p793ofirb28s";

                try {
                    let delResp = await DataSource.shared.deleteGoogleCalendarEvent(this.createdGoogleCalendarID, creatorEmail);
                } catch (e) {
                    console.log(e);
                }
            },

            changeSelectedFilesFormat() {
                for (let a = 0; a < this.arr_SelectedFileList.length; a++) {
                    this.arrobj_SelectedFiles.push(this.arr_SelectedFileList[a]);
                }
                this.convertSelectedFilesToFileFormat();
            },

            cancelFiles(obj, objKey) {

                let fileName = (obj.EventFIleName) ? obj.EventFIleName : obj.name;

                this.arrobj_SelectedFiles = this.arrobj_SelectedFiles.filter((d, dIndex) => {
                    let eachName = (d.EventFIleName) ? d.EventFIleName : d.name;
                    let isValid = true;
                    if (objKey === dIndex && eachName === fileName) {
                        isValid = false;
                    }

                    return isValid;
                });

                this.convertSelectedFilesToFileFormat();
            },

            convertSelectedFilesToFileFormat() {
                this.convertedFileForInsert = [];
                this.arrobj_SelectedFiles.forEach((images) => {
                    if (images.name === undefined) {
                        let url = "data:" + images.EventFileType + ";base64," + images.EventFileOriginal;
                        let fileName = images.EventFIleName;
                        let mimeType = images.EventFileType;
                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            this.convertedFileForInsert.push(file);
                        }).finally(() => {
                            this.getImagePreviews();
                        });
                    } else {
                        this.convertedFileForInsert.push(images);
                    }
                });
            },

            checkEventExpired() {
                this.isExpired = false;
                let expiredDatetime = moment().format("DD/MM/YYYY HH:mm:ss");
                let eventEndDatetime = moment(this.inputEventTime[1], "DD/MM/YYYY HH:mm:ss").add(1, 'hours').format("DD/MM/YYYY HH:mm:ss");
                if (moment(eventEndDatetime, "DD/MM/YYYY HH:mm:ss").unix() <= moment(this.serverCurrentDatetime).unix()) {
                    this.isExpired = true;
                }
            },

            checkRelatedUser() {
                let arrTeacherIds = [];
                if (this.assTeacherIds) {
                    arrTeacherIds = this.assTeacherIds.split(",");
                }

                let arrPierteacherIds = [];
                if (this.pierTeachersIds) {
                    arrPierteacherIds = this.pierTeachersIds.split(",");
                }

                let arrClassTeacherIds = [];
                if (this.classTeacherIds) {
                    arrClassTeacherIds = this.classTeacherIds.split(",");
                }

                if ( ( this.eventCreatedBy === Cookies.get('userIDSession') || arrTeacherIds.includes(Cookies.get('userIDSession'))
                    || arrPierteacherIds.includes(Cookies.get('userIDSession')) || arrClassTeacherIds.includes(Cookies.get('userIDSession')) ) ) {
                    this.isRelatedUser = true;
                }
            },

            showConfirmSendEmailModal() {
                // modal_RemoveItem
                this.$refs['modal_RemoveItem'].show();
            },

            hideConfirmSendEmailModal() {
                this.$refs['modal_RemoveItem'].hide();
            },

            removeItems(sendEmailFlag) {
                this.deleteGoogleCalendarEvent();
                this.$emit("deleteEvent", this.selectedEventID, sendEmailFlag);
                this.$refs['modal_RemoveItem'].hide();
            },

            checkDatetime() {
                this.checkShowDatetime = false;
                let expiredDatetime = moment().format("DD/MM/YYYY HH:mm:ss");
                let eventStartDatetime = moment(this.evtStartDatetime).add(-24, 'hours').format("DD/MM/YYYY HH:mm:ss");

                if (moment(eventStartDatetime, "DD/MM/YYYY HH:mm:ss").unix() <= moment(this.serverCurrentDatetime).unix()) {
                        this.checkShowDatetime = true;
                }

                if (this.schID === "SCH201400000480" || this.schID === "SCH201400000510") {
                    this.countdownStart = moment(this.serverCurrentDatetime).format("YYYY-MM-DD HH:mm:ss");
                    this.countdownEnd = moment(eventStartDatetime, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                    let eventCountdown = moment(this.evtStartDatetime).add(-24, 'hours').format("DD/MM/YYYY HH:mm:ss");

                    if (moment(eventCountdown, "DD/MM/YYYY HH:mm:ss").unix() <= moment(this.serverCurrentDatetime).unix()) {
                        this.eventStart = false;
                    }
                }
            },

            checkEventStart(type) {
                this.eventStart = true;
            },

            async getEventParticipantList() {
                try {
                    this.isLoad = true;

                    this.ParticipantNameListIntTemp = [];
                    this.ParticipantNameListInt = [];
                    this.CurrentParticipantList = [];

                    const partResponse = await DataSource.shared.getEventParticipantByEventID(this.eventID);
                    if (partResponse.code === "2") {
                        this.MasterParticipantList.forEach(m => {
                            this.CurrentParticipantList.push(m);
                        });
                        this.guestInt = [];
                        this.studentInt = [];
                        this.isLoad = false;
                    } else {
                        const participantResponse = partResponse.Table;
                        this.EventAllParticipant = partResponse.Table;
                        let editParticipantTemp = [];

                        this.arrobj_ptcParticipant = participantResponse;

                        if (participantResponse !== undefined) {
                            participantResponse.forEach(m => {
                                let my_object = {
                                    Type: m.EventParType,
                                    value: m.PaxName,
                                };
                                editParticipantTemp.push(my_object);
                            });
                        }

                        this.ParticipantNameListInt = editParticipantTemp;
                        this.guestInt = this.ParticipantNameListInt.filter(d => {
                            return d.Type === "Others";
                        });

                        let studentIntFilter = [];
                        if (participantResponse !== undefined) {
                            studentIntFilter = participantResponse.filter(d => {
                                return d.EventParType === "Student";
                            });
                        }

                        if (this.isStaff === false) {
                            this.studentInt = studentIntFilter;
                        } else {
                            let tempStudentInt = [];
                            studentIntFilter.forEach(m => {
                                let my_object = {
                                    Type: m.EventParType,
                                    value: m.EventParPaxID,
                                    label: m.PaxName
                                };
                                tempStudentInt.push(my_object);
                            });

                            if (this.studentInt.length === 0) {
                                this.studentInt = tempStudentInt;
                            }
                            // this.studentInt = tempStudentInt;
                        }

                        this.isLoad = false;
                    }

                } catch (e) {
                    console.log(e);
                }
            },

            showTimeslotModal() {
                this.$refs['modal_TimeslotList'].show();
            },

            hideTimeslotModal() {
                this.$refs['modal_TimeslotList'].hide();
            },

            combinePTCDateTime() {
                let selectStartDT = this.ptcDaterange[0] + ' ' + this.ptcStartTime + ':00';
                let selectEndDT = this.ptcDaterange[1] + ' ' + this.ptcEndTime + ':00';
                this.evtStartDatetime = moment(selectStartDT, "DD/MM/YYYY HH:mm:ss").toISOString();
                this.evtEndDatetime = moment(selectEndDT, "DD/MM/YYYY HH:mm:ss").toISOString();
            },

            openMoreGuidance() {
                if (this.isMoreGuidance === false) {
                    this.isMoreGuidance = true;
                } else {
                    this.isMoreGuidance = false;
                }
            },
          async updateParentTimeslotBooking(eventTimeslotID, eventParID, eventID, calEventHangoutLink, calEventID) {
            if (this.eventTimeslotID !== "" && this.eventParID !== "") {
              let timeslotBookingResp = await DataSource.shared.updateTimeslotBooking(eventTimeslotID, eventParID, eventID, calEventHangoutLink, calEventID);

              // console.log(timeslotBookingResp.code, "response");
              if (timeslotBookingResp.code === "1") {
                this.$notify({
                  title: lang('Success'),
                  message: "Selected Successful!",
                  type: 'success'
                });

                // if (this.eventRdEventType === "PTC") {
                //     this.checkEventExpired();
                // }
              } else if (timeslotBookingResp.code === "3") {
                this.$notify.error({
                  title: lang('Error'),
                  message: "Timeslot taken, Please select others timeslot!",
                });

                this.getEventTimeslot();
                this.isClickCount = 0;
                // this.isAvailable = true;
              } else {
                this.$notify.error({
                  title: lang('Error'),
                  message: "Selected timeslot unavailable!",
                });
                console.log(timeslotBookingResp.code, "save timeslot error code");
              }

              this.$vs.loading.close();
            } else {
              console.log(this.eventTimeslotID, "timeslot ID");
              console.log(this.eventParID, "par ID");
            }
          },
        },

    };
</script>
<style scoped>
    .el-date-editor {
        width: 100% !important;
    }

    .generated-time-slot-date-container {
        margin-bottom: 20px;
    }

    .each-time-slot-table {
        padding: 5px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        margin: 0 10px 20px 0;
        border: 1px solid #409eff;
        width: 80px; /*100px*/
        font-size: 12px;
        background: #409eff;
        color: white;
        position: relative;
    }

    .each-time-slot-table.disable {
        background: #ffffff;
        /*background: #409eff;*/
        /*color: white;*/
        color: black;
    }

    .ptc-par-name {
        display: block;
        position: absolute;
        top: -15px;
        background: #f7f7f7;
        border-radius: 4px;
        color: black;
        max-width: 68px;
        line-height: 1;
    }

    .each-file-close {
        padding: 0 5px;
        border-radius: 50%;
        border: 1px solid #ccc;
        cursor: pointer;
        margin-left: 10px;
    }

    .event-onoffline {
      display: flex;
    }

    .event-onoffline > .el-radio {
      margin: 0;
    }
</style>

<style>
    .event-start-datetime #start-datetime,
    .event-end-datetime #end-datetime {
        width: 100%;
        padding: 5px;
        border-radius: 4px;
    }

    .ptc-time-range-container .el-input__icon {
        height: auto;
    }
</style>